export default {"src":"/_next/static/media/check-circle.2dbbd82c.gif","height":128,"width":128,"blurWidth":0,"blurHeight":0};